import { Injectable } from '@angular/core';
import * as dayjs from 'dayjs';
import { Utils } from '@services/utils';
import { WorkflowService } from './store';
import { MONTH_ADJUSTMENT_TOOLTIP } from './workflow.const';

@Injectable({
  providedIn: 'root',
})
export class CloseQuarterService {
  constructor(private workflowService: WorkflowService) {}

  getCloseQuarterTooltip(
    isMonthAdjustmentAvailable: boolean,
    isWorkflowAvailable: boolean,
    monthAdjustmentTooltipText = MONTH_ADJUSTMENT_TOOLTIP
  ): string {
    if (!isWorkflowAvailable) {
      const closeDate = dayjs(this.workflowService.trialMonthClose$.getValue());

      const monthName = Utils.MONTH_NAMES[closeDate.get('month')];

      return `${monthName} ${closeDate.get('year')} is not available to close`;
    }

    if (!isMonthAdjustmentAvailable) {
      return monthAdjustmentTooltipText;
    }

    return '';
  }
}
